import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError, checkBoxHelper } from '@shared/helpers/form.helper';
import { toNum } from '@shared/helpers/math.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { formPaths } from '@shared/constants/form-paths.const';
import { getCoopPescaControl } from './helpers/coop-pesca-form.helpers';

export const schedaCoopPescaRules: FormGroupRules = {
    my_CkPossiedeNatanti: (form: FormGroup) => {
        requiredByScPescaObbl(form, 'my_CkPossiedeNatanti');
    },

    my_CkGestisceCentriRaccoltaPescato: (form: FormGroup) => {
        requiredByScPescaObbl(form, 'my_CkGestisceCentriRaccoltaPescato');
    },

    my_CkGestisceMercatiIttici: (form: FormGroup) => {
        requiredByScPescaObbl(form, 'my_CkGestisceMercatiIttici');
    },

    my_CkGesctisceCentriAcquaColtura: (form: FormGroup) => {
        requiredByScPescaObbl(form, 'my_CkGesctisceCentriAcquaColtura');
    },

    my_CkSchPescaGestisceAltro: (form: FormGroup) => {
        requiredByScPescaObbl(form, 'my_CkSchPescaGestisceAltro');
    },

    my_NumNatantiFinoA10: (form: FormGroup) => {
        natantiHelper(form, 'my_NumNatantiFinoA10', 'my_NumNatantiOltre10');
    },

    my_NumNatantiOltre10: (form: FormGroup) => {
        natantiHelper(form, 'my_NumNatantiOltre10', 'my_NumNatantiFinoA10');
    },

    my_DescrNatanti: (form: FormGroup) => {
        ckPossiedeNatantiHelper(form, 'my_DescrNatanti');
    },

    my_SchPescaGestisceAltroDesc: (form: FormGroup) => {
        ckHelper(form, 'my_SchPescaGestisceAltroDesc', 'my_CkSchPescaGestisceAltro', 1);
    },

    my_AltreAttivitaPerSociPesca: (form: FormGroup) => {
        ckHelper(form, 'my_AltreAttivitaPerSociPesca', 'my_ckAttAltro', 1);
    },
};

const requiredByScPescaObbl = (form: FormGroup, targetPath: string): void => {
    checkBoxHelper(form, targetPath, 'my_ScPescaObbl', 1, formPaths.schedaCoopPesca);
};

const ckHelper = (form: FormGroup, targetPath: string, ckPath: string, ckTargetValue: number, suppCondition = true, errorStatus?: string): void => {
    const scPescaObbl: string = getCoopPescaControl(form, 'my_ScPescaObbl').value;
    checkBoxHelper(form, targetPath, ckPath, ckTargetValue, formPaths.schedaCoopPesca, suppCondition && scPescaObbl === '1', errorStatus);
};

const ckPossiedeNatantiHelper = (form: FormGroup, targetPath: string): void => {
    ckHelper(form, targetPath, 'my_CkPossiedeNatanti', 1);
};

const natantiHelper = (form: FormGroup, targetPath: string, otherPath: string): void => {
    const control = getCoopPescaControl(form, targetPath);
    const scPescaObbl: string = getCoopPescaControl(form, 'my_ScPescaObbl').value;
    const ckPossiedeNatanti: string = getCoopPescaControl(form, 'my_CkPossiedeNatanti').value;
    const otherValue: string = getCoopPescaControl(form, otherPath).value;
    const errors = control.errors ?? {};
    const isActive = scPescaObbl === '1' && ckPossiedeNatanti === '1';
    addRemoveError(toNum(control.value) === 0 && toNum(otherValue) === 0 && isActive, errors, `${targetPath}Required`, { status: REQUIRED_STATUS });

    control.setErrors(isEqual(errors, {}) ? null : errors);
};

export const CoopPescaFormValidators = Object.values(schedaCoopPescaRules);
